/*
 * Receipt option: syncs the "receipt" and "receipt_name" cart attributes via
 * the Cart AJAX API.
 *
 * Unchecked checkboxes are not submitted with the form, so the attribute is
 * synced on every change with fetch('/cart/update.js') — checked => "true",
 * unchecked => "false". Clearing receipt also clears receipt_name.
 *
 * A customer who is happy with the (unchecked) default never fires a `change`
 * event, so without more the cart never gets a "receipt" attribute at all and
 * the resulting order has no `receipt` key. submitDefaultOnce() posts the
 * displayed default a single time on page load, but only when the raw cart
 * attribute is unset (data-receipt-unset, rendered from the Liquid side
 * without a `| default` fallback) — once a value exists (from this or from a
 * real choice), it is never re-posted. Note: the off value must be the
 * non-empty string "false", not "" — Shopify drops attributes whose value is
 * an empty string, so "" would never persist onto the order either way.
 *
 * Uses document-level event delegation with a global guard so it keeps working
 * after the cart drawer re-renders its contents (which replaces the elements).
 */
(function () {
  if (window.__receiptOptionBound) return;
  window.__receiptOptionBound = true;

  var nameTimer = null;

  function syncReceipt(checked) {
    // Keep every receipt checkbox (cart page + cart drawer) in sync.
    document.querySelectorAll('.js-receipt-checkbox').forEach((cb) => {
      cb.checked = checked;
    });

    // Show/hide name input in all locations.
    document.querySelectorAll('.js-receipt-name-wrap').forEach((wrap) => {
      wrap.style.display = checked ? '' : 'none';
    });

    var attributes = { receipt: checked ? 'true' : 'false' };

    if (!checked) {
      // Clear the name field and attribute when receipt is deselected.
      document.querySelectorAll('.js-receipt-name').forEach((inp) => {
        inp.value = '';
      });
      attributes.receipt_name = '';
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    });
  }

  function submitDefaultOnce() {
    if (!document.querySelector('[data-receipt-unset="true"]')) return;
    var checkbox = document.querySelector('.js-receipt-checkbox');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { receipt: checkbox && checkbox.checked ? 'true' : 'false' } }),
    });
  }
  submitDefaultOnce();

  function syncReceiptName(value) {
    // Keep every name input in sync (cart page + cart drawer).
    document.querySelectorAll('.js-receipt-name').forEach((inp) => {
      if (inp.value !== value) inp.value = value;
    });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { receipt_name: value } }),
    });
  }

  document.addEventListener('change', (e) => {
    const checkbox = e.target.closest('.js-receipt-checkbox');
    if (checkbox) syncReceipt(checkbox.checked);
  });

  document.addEventListener('input', (e) => {
    const nameInput = e.target.closest('.js-receipt-name');
    if (!nameInput) return;
    clearTimeout(nameTimer);
    nameTimer = setTimeout(() => syncReceiptName(nameInput.value), 600);
  });
})();
